module.exports = __webpack_public_path__ + "static/img/xpcw-benefits.9e3b3ab6.png";